import React, {Component} from 'react'
import {Row, Col, Icon, Input, Checkbox, Button} from 'antd'

import 'styles/register.css'

class Register extends Component {
  render() {
    return (
      <div className="register container">
        <div className="top-box">
          <a href="#/login">
            <Icon type="left"/>
            <span>注册</span>
          </a>
        </div>
        <div className="form-box content-main">
          <Row>
            <Col className="two-word" span={5}>片&emsp;&emsp;区</Col>
            <Col span={19}>
              <Input placeholder="泸州政法委"/>
            </Col>
          </Row>
          <Row>
            <Col span={5}>手<span className="three-word">机</span>号</Col>
            <Col span={19}>
              <Input placeholder="请输入手机号"/>
            </Col>
          </Row>
          <Row>
            <Col className="two-word" span={5}>密&emsp;&emsp;码</Col>
            <Col span={19}>
              <Input placeholder="请输入密码"/>
            </Col>
          </Row>
          <Row>
            <Col span={5}>确认密码</Col>
            <Col span={19}>
              <Input placeholder="请输入确认密码"/>
            </Col>
          </Row>
          <Row>
            <Col span={5}>验<span className="three-word">证</span>码</Col>
            <Col span={13}>
              <Input placeholder="请输入确认密码"/>
            </Col>
            <Col span={6}>
              <Input className="reg-code" value="获取验证码" type="button"/>
            </Col>
          </Row>
          <label className="agree-box">
            <Checkbox/>
            <span>同意接受智慧社区Life使用协议</span>
          </label>
          <div className="next-btn">
            <Button>下一步</Button>
          </div>
        </div>
      </div>
    )
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/pages/register.js